<section class="container" >
  <div class="table-responsive" *ngIf="produtosPermitidos || produtosPermitidos.length">
    <table class="table table-hover">
      <thead>
      <tr>
        <th id="col-id" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'id'"
            [nomeAtributoExibicao]="'Código do Produto'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-sigla" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'sigla'"
            [nomeAtributoExibicao]="'Sigla do Produto'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-nome" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'nome'"
            [nomeAtributoExibicao]="'Descrição do Produto'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-permitida" scope="col">
          <bn-ordenacao
            [ordenacao]="atributosOrdenacao"
            [atributo]="'permitida'"
            [nomeAtributoExibicao]="'Operação Permitida'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of produtosPermitidos">
        <td>{{ item.id }}</td>
        <td>{{ item.sigla }}</td>
        <td>{{ item.nome }}</td>
        <td>{{ (item?.permitida == true ? 'Sim' : 'Não') }}</td>
        <td class="text-start" id=col-acoes>
          <a href="javascript:void(0)" (click)="chamarModalExluirProduto(item.id)">
            <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Excluir produto"></i>
          </a>
          <a href="javascript:void(0)"
            bnConfirm
            tituloConfirm="Confirmação"
            msgConfirm="Confirmar a alteração no Código de modalidade operacional?"
            (onConfirm)="mudarStatusProduto(item.id)">
            <i class="fa cursor-pointer margin-left-5" [ngClass]="{'text-danger': item.permitida, 'fa-ban': item.permitida, 'fa-check': !item.permitida }"
              placement="left-top" [ngbTooltip]="tooltipMudarStatus(item)"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</section>
